import { graphql } from '../../graphql';

export const bulkPaidServices = graphql(`
  query PaidServices($targetIds: [ID!]!) {
    paidServices(targetIds: $targetIds, targetType: ITEM) {
      id
      title
    }
  }
`);

export const bulkPaidServiceOptions = graphql(`
  query PaidServiceOptions($paidServiceId: ID!, $targetIds: [ID!]!) {
    paidServiceOptions(paidServiceId: $paidServiceId, targetIds: $targetIds) {
      id
      name
      price
      priceWithDiscount(paymentMethodId: "wallet")
    }
  }
`);

export const bulkPaymentMethod = graphql(`
  query PaymentMethod($paidServiceId: ID!, $targetIds: [ID!]!) {
    paymentMethods(
      paidServiceId: $paidServiceId
      targetIds: $targetIds
      targetType: ITEM
    ) {
      id
      balance
      name
    }
  }
`);

export const getBulkItems = graphql(`
  query BulkItems($companyId: ID!, $first: Int, $cursor: String) {
    itemsConnection(
      first: $first
      after: $cursor
      filter: { companyId: $companyId }
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          area {
            value
            units
          }
          isLeased
          floor
          floors
          city {
            id
            name
          }
          location {
            id
            name
            fullName
          }
          hasMortgage
          hasInternalLoan
          price {
            total
            currency
          }
          company {
            id
            name
            targetType
          }
          isPaidDaily
          rooms
          hasBillOfSale
          hasRepair
          isVipped
          isFeatured
          updatedAt
          path
          preview {
            thumbnail
            f460x345
          }
        }
      }
    }
  }
`);
